import { render, staticRenderFns } from "./SlideImage.vue?vue&type=template&id=6b885aab&scoped=true&"
import script from "./SlideImage.vue?vue&type=script&lang=js&"
export * from "./SlideImage.vue?vue&type=script&lang=js&"
import style0 from "./SlideImage.vue?vue&type=style&index=0&id=6b885aab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b885aab",
  null
  
)

export default component.exports